module.exports = __webpack_public_path__ + "img/img5.5550f3d3.svg";